import { ShieldCheck, Wrench, Wallet, Cctv, Wifi, MapPin, Cloud, Zap, Video } from "lucide-react";

// ---- 2027 compliance benefits (why the bundle is the easy path) ----
export const COMPLIANCE_BENEFITS = [
  {
    icon: Wallet,
    title: "Low entry cost",
    desc: "No large upfront hardware purchase. Your dashcam is included in one simple monthly plan.",
  },
  {
    icon: Wrench,
    title: "Professional install included",
    desc: "Hardwired installation done at no extra cost by qualified auto electricians at approved locations.",
  },
  {
    icon: ShieldCheck,
    title: "Compliant from day one",
    desc: "Every unit records the cabin and the forward view simultaneously — exactly what the 2027 rules require.",
  },
];

// ---- Hardware + subscription bundle (Pro+) ----
// Prices vary by the instructor's subscription tier (Founding Instructor vs Pro).
// annual = monthly x 10 (2 months free); eff = annual / 12.
const price = (m) => ({ monthly: `$${m}`, annual: `A$${m * 10}`, eff: `$${(m * 10 / 12).toFixed(2)}` });

export const HARDWARE_TIERS = [
  {
    id: "premium-flagship", brand: "BlackVue", brandType: "premium",
    tier: "Premium Flagship", model: "BlackVue DR970X-2CH LTE",
    prices: { founding: price(80), pro: price(95) },
    tagline: "The connected benchmark. 4K clarity with built-in LTE and Cloud.",
    features: ["4K UHD forward + Full HD cabin", "Built-in LTE, live Cloud & GPS", "Intelligent parking mode", "256GB storage included"],
    icons: [Video, Wifi, Cloud], popular: false,
  },
  {
    id: "premium-standard", brand: "BlackVue", brandType: "premium",
    tier: "Premium Standard", model: "BlackVue DR770X-2CH",
    prices: { founding: price(70), pro: price(85) },
    tagline: "BlackVue reliability with sharp dual-channel recording.",
    features: ["Full HD forward + Full HD cabin", "Wi-Fi, GPS & Cloud-ready", "Parking mode & impact detection", "128GB storage included"],
    icons: [Video, Wifi, MapPin], popular: true,
  },
  {
    id: "value-pro", brand: "DriveAssure Value", brandType: "value",
    tier: "Value Pro", model: "DriveAssure Value Pro Cam",
    prices: { founding: price(60), pro: price(75) },
    tagline: "Our own hardwired unit — compliance-ready, sharper vision.",
    features: ["2K forward + Full HD cabin", "Wi-Fi & GPS logging", "Parking mode", "128GB storage included"],
    icons: [Video, Wifi, MapPin], popular: false,
  },
  {
    id: "value-core", brand: "DriveAssure Value", brandType: "value",
    tier: "Value Core", model: "DriveAssure Value Core Cam",
    prices: { founding: price(55), pro: price(70) },
    tagline: "The essential compliant unit. Everything you need, nothing you don't.",
    features: ["Full HD forward + Full HD cabin", "GPS logging", "Continuous loop recording", "64GB storage included"],
    icons: [Cctv, MapPin, Zap], popular: false,
  },
];
